// extracted by mini-css-extract-plugin
export default {"content":"Introduction_content__fxBmy","title":"Introduction_title__yst-u","buttons":"Introduction_buttons__jw8vQ"};